import * as tslib_1 from "tslib";
import { FormControl } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { map } from 'rxjs/operators';
var SEARCH_QUERY = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query getCompanies($where: CompanyWhereInput, $limit: Int, $offset: Int) {\n    companies(where: $where, orderBy: name_asc, limit: $limit, offset: $offset) {\n      items {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query getCompanies($where: CompanyWhereInput, $limit: Int, $offset: Int) {\n    companies(where: $where, orderBy: name_asc, limit: $limit, offset: $offset) {\n      items {\n        id\n        name\n      }\n    }\n  }\n"])));
var FcCompanyOutlinedSelectComponent = /** @class */ (function () {
    function FcCompanyOutlinedSelectComponent(apollo) {
        this.apollo = apollo;
    }
    FcCompanyOutlinedSelectComponent.prototype.searchCompanies = function (searchTerm, limit, offset) {
        return this.apollo
            .query({
            query: SEARCH_QUERY,
            variables: {
                where: {
                    archived: false,
                    name_contains: searchTerm
                },
                limit: limit,
                offset: offset
            }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['companies']['items'];
        }));
    };
    return FcCompanyOutlinedSelectComponent;
}());
export { FcCompanyOutlinedSelectComponent };
var templateObject_1;
